import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'formula-por-listas',
  template: `
  <div class="table-responsive">
    <table class="table table-hover">
     
      <tbody>
        <tr *ngFor="let item of lista; let i = index">
          <td >
            <h5>{{item.descripcion}}</h5>
          </td>
          <td>
            <div class="p-0 border-checkbox-section">
                  <div class="border-checkbox-group">
                      <input
                        class="border-checkbox"
                        type="checkbox"
                        id="fila_{{item.id}}"
                        [(ngModel)]="item.estado"
                        >
                      <label class="border-checkbox-label" for="fila_{{item.id}}"></label>
                  </div>
              </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  `,
  styles: []
})
export class FormulaPorListasComponent implements OnInit {
  @Input() lista

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/formula-por-listas.component.ts